export default "__VITE_ASSET__CtJWfSYX__"